<template>
  <div class="container">
    <div class="private-ad-flow">
      <div class="private-ad-flow__inner-container">
        <ProgressBar
          :currentstep="currentStep"
          :eventbus="eventBus"
          :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
        />
        <Step1
          v-if="currentStep === 1"
          :event-bus="eventBus"
          :initial-designation-lists="initialDesignationLists"
          :initial-license-plate="initialLicensePlate"
          :product-type-id="productTypeId"
          :variant="vehicleData.variant"
          :error-collection="errorCollection"
          :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
        ></Step1>
        <Step2
          v-if="currentStep === 2"
          :event-bus="eventBus"
          :color-list="colorListTemp"
          :vehicle-data="vehicleData"
          :table-data="tableData"
          :error-collection="errorCollection"
          :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
          :registration-date-str-initial="registrationDateStrInitial"
          :is-update="isUpdate"
        ></Step2>
        <Step3
          v-if="currentStep === 3"
          :event-bus="eventBus"
          :listEquipment="productTypePropertyListTemp"
          :vehicle-data="vehicleData"
          :error-collection="errorCollection"
          :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
          :is-update="isUpdate"
          :video-id="videoId"
          :video-src="videoSrc"
        ></Step3>
        <Step4
          v-if="currentStep === 4"
          :event-bus="eventBus"
          :vehicle-data="vehicleData"
          :error-collection="errorCollection"
          :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
          :is-update="isUpdate"
          ref="step4"
        ></Step4>
        <Step5
          v-if="currentStep === 5"
          :event-bus="eventBus"
          :ad-id="vehicleData.adId"
          :contact-information="vehicleData.contactInformation"
          :table-data="tableDataFinal"
          :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
          :is-update="isUpdate"
          :is-active="isActive"
          :initial-ad-url="vehicleData.url"
          :my-ads-url="myAdsUrl"
          :dashboard-url="dashboardUrl"
        ></Step5>
      </div>
    </div>
  </div>
</template>
<script>
import { app } from '@/main'
import mitt from 'mitt'

import NumberPresentationFunctions from '@components/Shared/NumberPresentationFunctions.vue'

import Step1 from './Steps/Step1.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import ProgressBar from './Components/ProgressBar/ProgressBar.vue'

import {
  PrivateAdFlowStep1Shown,
  PrivateAdFlowStep1LicensePlate,
  PrivateAdFlowStep1ManualSelection,
  PrivateAdFlowStep2Shown,
  PrivateAdFlowStep3Shown,
  PrivateAdFlowStep4Shown,
  PrivateAdFlowStep5Shown,
} from '@/events'

export default {
  mixins: [NumberPresentationFunctions],
  components: {
    ProgressBar,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
  },
  props: {
    initialDesignationLists: { default: null, type: Array },
    initialLicensePlate: { default: '', type: String },
    productTypeId: { default: null, type: Number },
    colorList: { default: null, type: Array },
    productTypePropertyList: {
      default: () => {
        return []
      },
      type: Array,
    },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
    product: { default: null, type: Object },
    myAdsUrl: { default: '', type: String },
    dashboardUrl: { default: '', type: String },
  },
  data() {
    return {
      eventBus: mitt(),
      currentStep: 0,
      vehicleData: {},
      vehiclePropertyList: [],
      licensePlate: '',
      tableData: [],
      tableDataFinal: [],
      propertyUpdateArray: [],
      colorListTemp: [],
      productTypePropertyListTemp: [],
      errorCollection: [],
      registrationDateStrInitial: false,
      isActive: false,
      isUpdate: false,
      videoId: '',
      videoSrc: '',

      stepsShown: 0,
    }
  },
  watch: {
    currentStep(newValue, oldValue) {
      if (newValue == oldValue) return
      this.releaseStepLock()
    },
  },
  methods: {
    releaseStepLock() {
      this.eventBus.emit('step-changed')
    },
    showStepOneDialog() {
      app.toast.warning(
        'Er du helt sikker på du vil starte forfra med din annonce?',
        () => {
          setTimeout(() => {
            document.location.reload()
          }, 100)
        },
        'Start forfra'
      )
    },
    stepLoaded(stepNo) {
      if (stepNo <= this.stepsShown) return

      switch (stepNo) {
        case 1:
          PrivateAdFlowStep1Shown()
          break
        case 2:
          PrivateAdFlowStep2Shown()
          if (this.licensePlate !== '') {
            PrivateAdFlowStep1LicensePlate()
          } else {
            PrivateAdFlowStep1ManualSelection()
          }
          break
        case 3:
          PrivateAdFlowStep3Shown()
          break
        case 4:
          PrivateAdFlowStep4Shown()
          break
        case 5:
          PrivateAdFlowStep5Shown()
          break
      }
    },
    advanceFlow() {
      if (this.currentStep === 1) {
        this.saveAd()
      } else if (this.currentStep < 4) {
        if (this.propertyUpdateArray.length > 0) {
          this.updateProperties()
        } else {
          this.currentStep++
          if (this.stepsShown < this.currentStep) {
            this.stepsShown = this.currentStep
          }
        }
      } else if (this.currentStep < 5) {
        this.updatePriceAndContactInformation()
      }
      history.pushState({ currentStep: this.currentStep }, '', null)
    },
    recedeFlow() {
      if (this.currentStep > 2) {
        this.currentStep--
        history.replaceState({ currentStep: this.currentStep }, '', null)
      } else {
        this.showStepOneDialog()
      }
    },
    quickStep(stepNo) {
      if (stepNo > 1) {
        this.currentStep = stepNo
      } else {
        this.showStepOneDialog()
      }
    },
    saveAd() {
      // resetting errorCollection
      this.errorCollection = []
      const data = {
        ProductTypeId: this.productTypeId,
        VariantId: this.vehicleData.variant.id,
        LicensePlate: this.licensePlate,
      }
      const owner = this
      // AXIOS til server
      app.axios.post('/Product/Create/', JSON.stringify(data)).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.errorCollection = resp.data.errorCollection
          owner.releaseStepLock()
        } else {
          owner.vehicleData = resp.data.data.productJsonModel
          if (
            owner.vehicleData.properties.filter(propItem => {
              return propItem.propertyTypeId === 18
            }).length > 0
          ) {
            owner.registrationDateStrInitial = true
          }
          owner.tableData = resp.data.data.tableData
          owner.currentStep++
          history.pushState({ currentStep: this.currentStep }, '', null)
        }
      })
    },
    updateProperties() {
      // resetting errorCollection
      this.errorCollection = []

      if (this.isUpdate && this.propertyUpdateArray.length === 0) {
        this.currentStep++
        history.pushState({ currentStep: this.currentStep }, '', null)
        return
      }

      const propertyData = []
      this.propertyUpdateArray.forEach(item => {
        propertyData.push({ propertyTypeId: item.id, value: item.name })
      })
      const data = {
        ProductId: this.vehicleData.productId,
        Properties: propertyData,
      }
      const owner = this
      // AXIOS til server
      app.axios
        .post('/Product/UpdateProperties/', JSON.stringify(data))
        .then(resp => {
          if (
            resp.data.errorCollection &&
            resp.data.errorCollection.length > 0
          ) {
            owner.errorCollection = resp.data.errorCollection
            owner.releaseStepLock()
          } else {
            owner.propertyUpdateArray = []
            owner.currentStep++
            history.pushState({ currentStep: this.currentStep }, '', null)
          }
        })
    },
    updatePriceAndContactInformation() {
      // resetting errorCollection
      this.errorCollection = []

      const data = {
        ProductId: this.vehicleData.productId,
        PriceInformation: {
          Price: this.vehicleData.priceInformation.price,
          IsVatIncluded: this.vehicleData.priceInformation.isVatIncluded,
          IsRegistrationTaxIncluded: this.vehicleData.priceInformation
            .isRegistrationTaxIncluded,
        },
      }

      const contactInfoSuccess = async () => {
        return this.$refs.step4.validateAndSaveContactInformations()
      }

      const owner = this
      // AXIOS til server
      app.axios.post('/Product/SetPrice/', JSON.stringify(data)).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.errorCollection = resp.data.errorCollection
          owner.releaseStepLock()
        } else {
          owner.vehicleData.adId = resp.data.data

          contactInfoSuccess().then(
            response => {
              if (response) {
                owner.prepareTableDataFinal()
                owner.currentStep++
                history.pushState({ currentStep: this.currentStep }, '', null)
              }
              this.releaseStepLock()
            },
            // Hvis kaldet fejler fuldstændig
            () => {
              owner.releaseStepLock()
            }
          )

          // if (contactInfoSuccess) {
          //   owner.prepareTableDataFinal()
          // } else {
          //   owner.releaseStepLock()
          // }
        }
      })
    },
    prepareTableDataFinal() {
      this.tableDataFinal = []
      if (this.vehicleData.make && this.vehicleData.make.name != undefined)
        this.tableDataFinal.push({
          key: 'Mærke',
          value: this.vehicleData.make.name,
        })
      if (this.vehicleData.model && this.vehicleData.model.name != undefined)
        this.tableDataFinal.push({
          key: 'Model',
          value: this.vehicleData.model.name,
        })
      if (
        this.vehicleData.variant &&
        this.vehicleData.variant.name != undefined
      )
        this.tableDataFinal.push({
          key: 'Variant',
          value: this.vehicleData.variant.name,
        })
      this.tableDataFinal.push({
        key: '1. Indregistrering',
        value: this.vehicleData.registrationDateFirst,
      })
      this.tableDataFinal.push({
        key: 'Kørte kilometer',
        value:
          this.thousandSeparation(this.vehicleData.kilometers.name) + ' km',
      })
      this.tableDataFinal.push({
        key: 'Pris',
        value:
          this.thousandSeparation(
            this.vehicleData.priceInformation.price.toString()
          ) + ' kr.',
      })
    },
    variantChosen(value) {
      const variantObject = { id: value, name: '' }
      this.vehicleData.variant = variantObject
    },
    onSetColor(colorId) {
      this.colorListTemp = JSON.parse(JSON.stringify(this.colorList))
      this.colorListTemp.forEach(item => {
        if (item.value == colorId) {
          item.selected = true
        }
      })
    },
    setLicensePlate(value) {
      this.licensePlate = value.toUpperCase()
    },
    onSetProductProperty(keyValuePair) {
      this.productTypePropertyListTemp.forEach(propertyObj => {
        if (Number(propertyObj.value) === keyValuePair.id) {
          propertyObj.selected = Boolean(JSON.parse(keyValuePair.name))
        }
      })

      // Da det er bool værdier fjerner vi indexet fra update listen, hvis den findes i forvejen, da den så er sat tilbage til det initielle
      this.propertyUpdateArray.forEach((propItem, key) => {
        if (propItem.id == keyValuePair.id) {
          this.propertyUpdateArray.splice(key, 1)
          return
        }
      })
      this.propertyUpdateArray.push(keyValuePair)
    },
    preparePropertyUpdate(keyValuePair) {
      const keys = Object.keys(this.vehicleData)
      keys.forEach(key => {
        const dataObj = this.vehicleData[key]
        if (dataObj.id == keyValuePair.id) {
          this.vehicleData[key] = keyValuePair
        }
      })

      let arrayItemUpdated = false
      // Updating the property within the propertyUpdateArray if found
      this.propertyUpdateArray.forEach(propItem => {
        if (propItem.id == keyValuePair.id) {
          propItem.name = keyValuePair.name
          arrayItemUpdated = true
        }
      })
      // If the items hasn't been updated, it does not exist and will be added
      if (!arrayItemUpdated) {
        this.propertyUpdateArray.push(keyValuePair)
      }
    },
    onImageUploaded(fileBase64String) {
      const owner = this
      const data = {
        ProductId: owner.vehicleData.productId,
        ImageBase64: fileBase64String,
      }
      app.axios
        .post('/api/PrivateAd/UploadImage/', data)
        .then(resp => {
          if (
            resp.data.errorCollection &&
            resp.data.errorCollection.length > 0
          ) {
            owner.error(resp.data.errorCollection[0].errorMessage)
          } else {
            owner.eventBus.emit('get-images-callback')
          }
        })
        .catch(() => {
          // if error occurs reset image upload
          owner.eventBus.emit('reset-image-upload')
        })
    },
    onImageRotated(item) {
      const owner = this

      const data = {
        productId: this.vehicleData.productId,
        guid: item.filenameGuid,
      }
      app.axios.post('/api/PrivateAd/RotateImage/', data).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.error(resp.data.errorCollection[0].errorMessage)
        } else {
          owner.eventBus.emit('get-images-callback')
        }
      })
    },
    onImageMoved(data) {
      const owner = this

      data.productId = this.vehicleData.productId

      app.axios.post('/api/PrivateAd/MoveImage/', data).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.error(resp.data.errorCollection[0].errorMessage)
        }
      })
    },
    onImageDeleted(item) {
      const owner = this
      const data = {
        productId: this.vehicleData.productId,
        guid: item.filenameGuid,
      }
      app.axios.post('/api/PrivateAd/DeleteImage/', data).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.error(resp.data.errorCollection[0].errorMessage)
        } else {
          owner.eventBus.emit('get-images-callback')
        }
      })
    },
    onVimeoVideoUploaded(videoId) {
      const owner = this
      const data = {
        productId: this.vehicleData.productId,
        vimeoId: videoId,
      }
      app.axios.post('/api/video/SaveVideoId', data).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.error(resp.data.errorCollection[0].errorMessage)
        } else {
          this.videoId = videoId
        }
      })
    },
    onVimeoVideoUploadedSrcReady(videoSrc) {
      this.videoSrc = videoSrc
    },
    onVimeoVideoDeleted() {
      const owner = this
      const data = {
        productId: this.vehicleData.productId,
      }

      app.axios.post('/api/video/DeleteVideo', data).then(resp => {
        if (resp.data.errorCollection && resp.data.errorCollection.length > 0) {
          owner.error(resp.data.errorCollection[0].errorMessage)
        } else {
          this.videoId = null
        }
      })
    },
    onSetPriceValue(price) {
      if (price) {
        this.vehicleData.priceInformation = price
      }
    },
    onSetContactInformation(productContactInformation) {
      if (productContactInformation) {
        this.vehicleData.contactInformation = productContactInformation
      }
    },
    populateByExistingProduct() {
      this.vehicleData = this.product.productJsonModel
      this.licensePlate = this.product.productJsonModel.registrationNumber
      this.currentStep = 2
      this.tableData = this.product.tableData
      this.registrationDateStrInitial = this.licensePlate !== undefined // True hvis ovenstående indeholder regdato, men tænker det skal sendes med fra backend i stedet for.

      this.isUpdate = true
      this.isActive = this.product.productJsonModel.isActive
    },
  },
  created() {
    this.colorListTemp = JSON.parse(JSON.stringify(this.colorList))
    this.productTypePropertyListTemp = JSON.parse(
      JSON.stringify(this.productTypePropertyList)
    )
    if (
      this.product != undefined &&
      this.product.productJsonModel != undefined
    ) {
      this.videoId = this.product.productJsonModel.vimeoId

      if (this.product.productJsonModel.productId != undefined) {
        this.populateByExistingProduct()
      }
    }
  },
  mounted() {
    const owner = this
    if (this.eventBus) {
      this.eventBus.on('advance-flow', this.advanceFlow)
      this.eventBus.on('recede-flow', this.recedeFlow)
      this.eventBus.on('quickstep', this.quickStep)

      this.eventBus.on('variant-selection-callback', this.variantChosen)
      this.eventBus.on(
        'variant-selection-license-plate-callback',
        this.setLicensePlate
      )
      this.eventBus.on('property-set-callback', this.preparePropertyUpdate)
      this.eventBus.on('set-color-callback', this.onSetColor)

      this.eventBus.on(
        'product-property-set-callback',
        this.onSetProductProperty
      )

      this.eventBus.on('image-uploaded-callback', this.onImageUploaded)
      this.eventBus.on('image-rotated-callback', this.onImageRotated)
      this.eventBus.on('image-deleted-callback', this.onImageDeleted)
      this.eventBus.on('image-moved-callback', this.onImageMoved)

      this.eventBus.on('video-uploaded-callback', this.onVimeoVideoUploaded)
      this.eventBus.on(
        'video-uploaded-src-callback',
        this.onVimeoVideoUploadedSrcReady
      )
      this.eventBus.on('video-deleted-callback', this.onVimeoVideoDeleted)

      this.eventBus.on('set-price-value-change', this.onSetPriceValue)
      this.eventBus.on(
        'set-contact-information-callback',
        this.onSetContactInformation
      )

      this.eventBus.on('stepLoaded', this.stepLoaded)
      this.eventBus.on('publish-clicked', this.publishClicked)
    }

    if (this.currentStep === 0) {
      this.currentStep = 1
    }
    // set current step
    history.pushState({ currentStep: this.currentStep }, '', null)
    window.onpopstate = () => {
      if (history.state !== null) {
        const currentStep = owner.currentStep,
          historyStep = history.state.currentStep

        if (historyStep > currentStep) {
          // go forward
          owner.advanceFlow()
        } else if (historyStep < currentStep) {
          // go backward
          owner.recedeFlow()
        }
      }
    }
  },
}
</script>

<style lang="scss">
@import 'PrivateAdFlow.scss';
</style>
